export default __webpack_public_path__ + "0bc333109fe50e737a1360eb2a4cd3d8.svg";